import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';

export default function EstacionInput({ value, onChange, placeholder, style, codLinea, soloAv = true }) {
  const [query, setQuery] = useState(value || '');
  const [sugerencias, setSugerencias] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [loading, setLoading] = useState(false);
  const timeout = useRef(null);
  const ref = useRef(null);

  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const buscar = (q) => {
    setQuery(q);
    onChange(q);
    clearTimeout(timeout.current);
    if (q.length < 2) { setSugerencias([]); setAbierto(false); return; }
    setLoading(true);
    timeout.current = setTimeout(async () => {
      try {
        const r = await api.get(`/dependencias/?q=${encodeURIComponent(q)}&solo_av=${soloAv}&limit=8`);
        setSugerencias(r.data);
        setAbierto(true);
      } catch {}
      setLoading(false);
    }, 250);
  };

  const seleccionar = (dep) => {
    setQuery(dep.nombre);
    onChange(dep.nombre, dep);
    setSugerencias([]);
    setAbierto(false);
  };

  const iconos = { 'E': '🚉', 'B': '🔀', 'T': '🔧', 'K': '📍', 'P': '🅿️' };

  return (
    <div ref={ref} style={{ position: 'relative', ...style }}>
      <input
        value={query}
        onChange={e => buscar(e.target.value)}
        onFocus={() => query.length >= 2 && sugerencias.length > 0 && setAbierto(true)}
        placeholder={placeholder || 'Estacion...'}
        style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' }}
      />
      {loading && (
        <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 12, color: '#aaa' }}>...</div>
      )}
      {abierto && sugerencias.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000, maxHeight: 280, overflowY: 'auto', marginTop: 2 }}>
          {sugerencias.map((dep, i) => (
            <div key={i} onMouseDown={() => seleccionar(dep)}
              style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 10 }}
              onMouseEnter={e => e.currentTarget.style.background = '#f8f8f6'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              <span style={{ fontSize: 16 }}>{iconos[dep.tipo] || '📍'}</span>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500 }}>{dep.nombre}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{dep.cod_depend} · tramo {dep.tramo}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
